import { Component } from "react";

// Filet de sécurité global : si un composant plante pendant le rendu (accès
// à une propriété d'un objet inattendu, réponse API partielle, etc.), React
// démonte tout l'arbre et l'utilisateur se retrouve sur une page totalement
// blanche, sans aucun message — ce qui est arrivé sur le tableau de bord
// (voir Dashboard.js) et qui pourrait se reproduire ailleurs. Cette
// ErrorBoundary rattrape ces erreurs de rendu et affiche un message clair
// avec un bouton de rechargement, plutôt qu'un écran vide.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Erreur de rendu interceptée par ErrorBoundary :", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white p-6">
          <div className="max-w-md text-center space-y-4">
            <h1 className="text-lg font-semibold text-gray-900">Une erreur est survenue</h1>
            <p className="text-sm text-gray-500">
              L'application a rencontré un problème inattendu et n'a pas pu afficher cette page.
              Essayez de recharger la page ; si le problème persiste, contactez le support.
            </p>
            <button
              className="inline-flex items-center px-4 py-2 rounded-md bg-sky-700 text-white text-sm font-medium hover:bg-sky-600"
              onClick={() => window.location.reload()}
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
